import clsx from "clsx";
import GradientWrapper from "./Gradient"

type SplashPillProps = {
    label: string
    tilt?: string;
}

export default function SplashPill({ label, tilt }: SplashPillProps) {
    return (
        <div className={clsx(
            "relative flex justify-center items-center bg-white px-4 py-2 border-2 border-white rounded-full",
            tilt
        )}>
            <p className="z-50 font-20-bold text-green-800 leading-[135%]">
                {label}
            </p>
            <GradientWrapper gradient="bg-gradient-extreme-light-linear" rounded="rounded-full" />
        </div>
    )
}